import { makeid } from 'utils/helpers/makeid';
import {
  reasonForCallOptions,
  reviewCareTeamContactInfoOptions,
} from 'infrastructure/consts/device-troubleshooting-modal';

export const AppendixCForm = [
  {
    key: makeid(10),
    title: 'Did you speak to patient?',
    description:
      'Choose other if unlisted family member & type in their relationship. (Ex: Daughter in law) Add Name of Individual you spoke to in other.',
    type: 'radio',
    required: true,
    name: 'whichPerson',
    options: [
      { label: 'Patient', value: 'Patient', key: makeid(10) },
      { label: 'Spouse', value: 'Spouse', key: makeid(10) },
      { label: 'Caregiver', value: 'Caregiver', key: makeid(10) },
      { label: 'Other', value: 'Other', key: makeid(10) },
    ],
    extra: [
      {
        type: 'text',
        name: 'otherPerson',
        readingTypeFor: ['min'],
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Call Type',
    type: 'radio',
    required: true,
    name: 'callType',
    options: [
      { label: 'Inbound', value: 'inbound', key: makeid(10) },
      { label: 'Outbound', value: 'outbound', key: makeid(10) },
    ],
    extra: [
      {
        key: makeid(10),
        type: 'checkbox',
        name: 'callTypeExtra',
        options: [
          {
            label:
              'Informed patient the call is being recorded for Quality assurance purposes',
            value: 'inform',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Reason for call',
    type: 'checkbox',
    name: 'reasonForCall',
    required: true,
    options: reasonForCallOptions,
    extra: [
      {
        type: 'text',
        name: 'otherDetails',
        required: true,
        readingTypeFor: ['min'],
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
];

export const IntroCallForm = [
  {
    key: makeid(10),
    type: 'info',
    title: 'Intro Call Pathway',
    name: 'info',
    required: false,
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Patient Devices',
    type: 'checkbox',
    name: 'patientDevices',
    required: false,
    options: [
      {
        label: 'Blood Pressure Meter',
        value: 'bloodPressureMeter',
        key: makeid(10),
      },
      {
        label: 'Weight Scale',
        value: 'weightScale',
        key: makeid(10),
      },
      {
        label: 'Pulse Oximeter',
        value: 'pulseOximeter',
        key: makeid(10),
      },
      {
        label: 'Glucometer',
        value: 'glucometer',
        key: makeid(10),
      },
      {
        label: 'Sleep Mat',
        value: 'sleep Mat',
        key: makeid(10),
      },
      {
        label: 'Peak Flow Meter',
        value: 'peakFlowMeter',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },

  {
    key: makeid(10),
    title: 'Did patient receive set-up call from Onboarding team?',
    type: 'radio',
    name: 'didReceiveSetUpCall',
    required: false,
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Review RPM Program Goal',
    type: 'checkbox',
    name: 'reviewRPMProgramGoal',
    required: false,
    infoDescription:
      'To help you better self-manage your health, meaning you learn the skills to manage the symptoms of your condition.',
    infoIconLink: '/img/goal.svg',
    options: [
      {
        label: 'Hypertension',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Congestive Heart Failure',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Chronic Kidney Disease',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'COPD',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Asthma',
        value: 'other',
        key: makeid(10),
      },
      {
        label: 'Diabetes',
        value: 'other',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title:
      'Provider is encouraging patients to use remote devices to help track key vital signs in between office visits',
    type: 'checkbox',
    name: 'remoteDevices',
    required: false,
    options: [
      {
        label: 'Blood pressure on your long-term health',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Low blood oxygen on your breathing',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Weight as a way to identify CHF complications',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Weight as a way to identify CKD complications',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Blood glucose on your diabetes management',
        value: 'other',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: '',
    type: 'checkbox',
    name: 'reviewRPMProgramGoal2',
    required: false,
    options: [
      {
        label:
          'Advised patient that remote devices provide the care team with another tool to assess the effectiveness of medications and interventions',
        value: 'introductoryCall',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Review Care Team Contact Info',
    description: 'Review what happens next',
    type: 'checkbox',
    name: 'reviewCareTeam',
    required: false,
    options: reviewCareTeamContactInfoOptions,
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Review care team contact information',
    type: 'checkbox',
    name: 'careTeamContactInformation',
    required: false,
    options: [
      {
        label:
          'A patient assistance phone line with nurses and medical assistants on staff is available 24/7 by calling 1-888-407-4108',
        value: 'other',
        key: makeid(10),
      },
      {
        label:
          'The Remote Patient Monitoring program is not an emergency service; rather an educational tool that helps you and your care team to better manage your health',
        value: 'other',
        key: makeid(10),
      },
      {
        label:
          'If you have an emergency, you always want to seek care immediately. Go to the Urgent Care or emergency room',
        value: 'other',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
];

export const NormalReadingsForm = [
  {
    key: makeid(10),
    type: 'info',
    title: 'Normal Readings Pathway',
    name: 'info',
    required: false,
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Reading type that has been normal',
    type: 'checkbox',
    name: 'readingTypes',
    required: false,
    options: [
      {
        label: 'Blood pressure',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Blood glucose',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'SpO2',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Weight',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    type: 'info',
    title: 'Congratulate the patient!',
    name: 'info',
    readingTypeFor: ['min'],
    alignCenter: true,
    required: false,
    iconLink: '/img/horn.svg',
  },
  {
    key: makeid(10),
    title: 'What has patient been doing differently lately?',
    type: 'checkbox',
    name: 'doingDifferently',
    required: false,
    options: [
      {
        label: 'Changes in medication',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Changes in diet',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Changes in physical activity',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Changes in stress level',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Open ended patient driven goal setting',
    description: [
      '– What are some things you’d like to work on to keep your health on track?',
      '– Are you facing any barriers to achieving these goals?',
      '*Consider sending relevant education to support this goal',
    ].join('\n'),
    type: 'text',
    name: 'patientGoalSetting',
    required: false,
    readingTypeFor: ['min'],
  },
];

export const DeviceTroubleshootingForm = [
  {
    key: makeid(10),
    type: 'info',
    title: 'Device Troubleshooting Pathway',
    name: 'info',
    required: false,
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Device that needs troubleshooting',
    type: 'checkbox',
    name: 'deviceThatNeedsTroubleshooting',
    required: false,
    options: [
      {
        label: 'Sleep Mat',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Glucose Meter',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Peak Flow Meter',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Blood Pressure Monitor',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Thermometer',
        value: 'other',
        key: makeid(10),
      },
      {
        label: 'Weight Scale',
        value: 'other',
        key: makeid(10),
      },
      {
        label: 'Pulse Oximeter',
        value: 'other',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Reason for troubleshooting',
    type: 'checkbox',
    name: 'reasonForTroubleshooting',
    required: false,
    options: [
      {
        label: 'Readings not accurate',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Readings not transmitting successfully',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Error messages',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Device malfunction',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'General Advice for Accurate Reading Transmission',
    type: 'checkbox',
    name: 'readingTransmission',
    required: false,
    options: [
      {
        label: 'Charge batteries a minimum of 2-3 hours weekly',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label:
          'Bring device to next office visit to compare with office reading',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Make sure device is not plugged in while taking a reading',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Do not remove the SIM card from the device',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    type: 'info',
    title: 'Patient Education for Best Practice Device Use',
    name: 'info',
    readingTypeFor: ['min'],
    alignCenter: true,
    required: false,
    iconLink: '/img/info.svg',
  },
  {
    key: makeid(10),
    title: 'Blood Pressure Monitor',
    type: 'checkbox',
    name: 'bloodPressureMonitor',
    headerCollapse: true,
    headerIconLink: '/img/blood-pressure-monitor.svg',
    required: false,
    options: [
      {
        label: 'Sit relaxed in a chair for at least 5 minutes',
        value: 'sitRelaxed',
        key: makeid(10),
      },
      {
        label:
          'Place your feet flat on the floor (not crossed) with your back straight and supported',
        value: 'feetFlatFloor',
        key: makeid(10),
      },
      {
        label: 'Rest your arm comfortably on a flat surface at heart level',
        value: 'armFlatSurface',
        key: makeid(10),
      },
      {
        label: 'Ensure cuff is empty of air before applying',
        value: 'cuffIsEmpty',
        key: makeid(10),
      },
      {
        label: 'Place the bottom of the cuff above the bend of the elbow',
        value: 'cuffAboveBend',
        key: makeid(10),
      },
      {
        label:
          'Make sure the tube is running down the arm and over the inside of the elbow',
        value: 'tubeIsRunning',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Glucometer',
    type: 'checkbox',
    name: 'glucometer',
    headerCollapse: true,
    headerIconLink: '/img/glucometer.svg',
    required: false,
    options: [
      {
        label: 'Advised patient to bring device to office for QC',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Advised patient to check test strips for moisture exposure',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label:
          'First, wash your hands and set out your glucometer, a lancet, and a test strip',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'Sometimes it helps to warm your hands first. This can make the blood flow easier',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          'Try rubbing your hands together briskly. You can also run them under warm water. Just be sure to dry them well since wet hands can dilute the blood sample. This may result in a lower number',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          'Turn on the glucometer and place a test strip in the machine when it is ready',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'The glucometer reads the room temperature in Celsius',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Watch the indicator for placing the blood on the strip',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          "Make sure your hand is dry and wipe the area you've selected with an alcohol prep pad. Wait until the alcohol evaporates",
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          'Pierce your fingertip on the side of your finger, between the bottom of your fingernail to the tip of your nail',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          "The type of blood drop you need is based on the type of strip you're using",
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Place the drop of blood on or at the side of the strip',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          "The glucometer will take a few moments to calculate the blood sugar reading. Follow your doctor's orders for what to do based on the blood sugar reading",
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          'If your finger is still bleeding, use the alcohol prep pad to blot the site',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Device Quality Control instructions',
    type: 'link',
    required: false,
    name: 'link',
    link: 'https://sites.google.com/accuhealth.tech/compass/devices/g427b/test-readings',
    extra: [
      {
        key: makeid(10),
        title: '',
        type: 'checkbox',
        name: 'performedDeviceQC',
        required: false,
        options: [
          {
            label: 'Performed device QC with patient',
            value: 'introductoryCall',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
      {
        key: makeid(10),
        title: '',
        type: 'checkbox',
        name: 'controlSolutionOrdered',
        required: false,
        options: [
          {
            label: 'Control solution ordered',
            value: 'introductoryCall',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Weight Scale',
    type: 'checkbox',
    name: 'weightScale',
    headerCollapse: true,
    headerIconLink: '/img/weight-scale.svg',
    required: false,
    options: [
      {
        label: 'Weigh at the same time in the morning, after you urinate',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label:
          'Weigh while wearing what you sleep in, before eating or drinking',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Weigh using the same scale on a flat, hard surface',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Pulse Oximeter',
    type: 'checkbox',
    name: 'pulseOximeter',
    headerCollapse: true,
    headerIconLink: '/img/pulse-oximeter.svg',
    required: false,
    options: [
      {
        label: 'Turn on the pulse oximeter. (Check that it has batteries.)',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Clip it on the end of a finger, with your nail facing up',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: "You'll see the results in a few seconds",
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'The device gives two results: your blood oxygen level (SpO2) and your pulse rate (PR)',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'The device may not show any results if you have cold hands or you wear nail polish or artificial nails',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Peak Flow Meter',
    type: 'checkbox',
    name: 'peakFlowMeter',
    headerCollapse: true,
    headerIconLink: '/img/peak-flow-meter.svg',
    required: false,
    options: [
      {
        label:
          'Try to measure between noon and 2p each day to find your personal best',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Move the marker to the bottom of the numbered scale',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Stand up straight',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Take a deep breath. Fill your lungs all the way',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'Hold your breath while you place the mouthpiece in your mouth, between your teeth. Close your lips around it. Do not put your tongue against or inside the hole',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'Blow out as hard and fast as you can in a single blow. Your first burst of air is the most important. So, blowing for a longer time will not affect your result',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'Write down the number you get. But, if you coughed or did not do the steps right, do not write down the number. Instead, do the steps over again',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'Move the marker back to the bottom and repeat all these steps 2 more times. The highest of the 3 numbers is your peak flow number',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Device Troubleshooting',
    description:
      'Click the button below device type to access troubleshooting steps.',
    type: 'link',
    required: false,
    name: 'link',
    link: 'https://sites.google.com/accuhealth.tech/compass/devices',
    extra: [
      {
        type: 'text',
        name: 'deviceTroubleshootingText',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Device Troubleshooting Outcome',
    type: 'radio',
    required: false,
    name: 'outcome',
    options: [
      {
        label:
          'Device troubleshooting successful. Confirmed with reading done on phone',
        value: 'success',
        key: makeid(10),
      },
      {
        label: 'Device troubleshooting unsuccessful',
        value: 'unsuccess',
        key: makeid(10),
      },
    ],
    extra: [
      {
        key: makeid(10),
        label: 'Reason why troubleshooting was unsuccessful',
        type: 'text',
        name: 'deviceTroubleshootingUnsuccessfulText',
        readingTypeFor: ['min'],
      },
      {
        key: makeid(10),
        type: 'checkbox',
        name: 'extraDeviceTroubleshooting',
        required: false,
        options: [
          {
            label: 'Address confirmed and Tellichecker ticket submitted',
            value: 'introductoryCall',
            key: makeid(10),
          },
          {
            label: 'Device replacement ordered',
            value: 'introductoryCall',
            key: makeid(10),
          },
        ],
      },
    ],
    readingTypeFor: ['min'],
  },
];

export const MonthlyInteractionCallForm = [
  {
    key: makeid(10),
    type: 'info',
    title: 'Monthly Interaction Call Pathway',
    name: 'info',
    required: false,
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Did patient complete RPM Follow-Up SMS form?',
    type: 'radio',
    required: false,
    name: 'isPatientCompleteRpmSMSForm',
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    extra: [
      {
        key: makeid(10),
        label: 'Is patient experiencing any symptoms or health concerns?',
        type: 'radio',
        required: false,
        divider: true,
        name: 'isPatientHaveExpEtc',
        options: [
          { label: 'Yes', value: 'yes', key: makeid(10) },
          { label: 'No', value: 'no', key: makeid(10) },
        ],
        readingTypeFor: ['min'],
        extra: [
          {
            key: makeid(10),
            label: 'Link',
            type: 'link',
            required: false,
            divider: true,
            name: 'link',
            link: 'https://sites.google.com/accuhealth.tech/compass/pcc/faqs/clinical/transfer-to-clinical-team',
            readingTypeFor: ['min'],
          },
        ],
      },
    ],
    readingTypeFor: ['min'],
  },

  {
    key: makeid(10),
    title: 'Do you have any questions about your readings today?',
    type: 'radio',
    required: false,
    name: 'readingQuestionsRadio',
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    extra: [
      {
        key: makeid(10),
        label: 'Additional Details',
        type: 'text',
        required: false,
        divider: true,
        name: 'readingQuestionsText',

        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Any recent or upcoming appointments with your provider?',
    type: 'radio',
    required: false,
    divider: true,
    name: 'recentUpcomingAppointments',
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    extra: [
      {
        label: 'Date',
        type: 'datepicker',
        name: 'recentUpcomingAppointmentsDatePicker',
        required: false,
        key: makeid(10),
        options: [
          {
            label: 'Date of appointment',
            value: 'recentUpcomingAppointmentsDate',
            type: 'min',
            disabled: false,
            key: makeid(10),
            readingTypeFor: ['min'],
          },
        ],
      },
      {
        label: 'Time',
        type: 'time',
        name: 'recentUpcomingAppointmentsDatePickerTime',
        required: false,
        key: makeid(10),
        options: [
          {
            label: 'Time of appointment',
            value: 'recentUpcomingAppointmentsTime',
            type: 'time',
            disabled: false,
            key: makeid(10),
            readingTypeFor: ['min'],
          },
        ],
      },
      {
        type: 'doctor-and-agencydoctor-select-box',
        required: false,
        name: 'recentUpcomingAppointmentsInput',
        key: makeid(10),
        options: [
          {
            label: 'Provider',
            disabled: false,
            type: 'text',
            value: 'recentUpcomingAppointmentsProvider',
            key: makeid(10),
            readingTypeFor: ['min'],
          },
        ],
      },
      {
        type: 'appointment-method-select-box',
        required: false,
        name: 'recentUpcomingAppointmentsMethodInput',
        key: makeid(10),
        options: [
          {
            label: 'Appointment method',
            disabled: false,
            type: 'text',
            value: 'recentUpcomingAppointmentsMethod',
            key: makeid(10),
            readingTypeFor: ['min'],
          },
        ],
      },
      {
        label: 'Appointment Details',
        type: 'text',
        name: 'recentUpcomingAppointmentsText',
        required: false,
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },

  {
    key: makeid(10),
    title: 'Any medication changes or questions?',
    type: 'checkbox',
    name: 'medicationChangesQuestionsCheckbox',
    required: false,
    options: [
      {
        label: 'Stopped/started a medication',
        value: 'stoppedStartedMedication',
        key: makeid(10),
      },
      {
        label: 'Had a dosage change',
        value: 'hadDosageChange',
        key: makeid(10),
      },
      {
        label: 'Having side effects',
        value: 'sideEffects',
        key: makeid(10),
      },
      {
        label: 'Need help with a refill/prior authorization',
        value: 'heloWithPriorRefillAuth',
        key: makeid(10),
      },
      {
        label: 'Other',
        value: 'other',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
    extra: [
      {
        key: makeid(10),
        label: 'Additional Details',
        type: 'text',
        name: 'medicationChangesFreeText',
        required: false,
        readingTypeFor: ['min'],
      },
    ],
  },

  {
    key: makeid(10),
    title: 'Are you facing any challenges to accessing your healthcare?',
    type: 'radio',
    required: false,
    name: 'accessToReadingHealtcare',
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    extra: [
      {
        key: makeid(10),
        title: 'Device that patient has not been using',
        type: 'checkbox',
        name: 'accessToReadingHealtcareCheckbox',
        required: false,
        options: [
          {
            label: 'Housing challenges',
            value: 'housingChallenges',
            key: makeid(10),
          },
          {
            label: 'Food insecurity',
            value: 'foodInsecurity',
            key: makeid(10),
          },
          {
            label: 'Financial hardship',
            value: 'financialHardship',
            key: makeid(10),
          },
          {
            label: 'Transportation',
            value: 'transportation',
            key: makeid(10),
          },
          {
            label: 'Stress/anxiety/overwhelm',
            value: 'stressAnxietyOverwhelm',
            key: makeid(10),
          },
          {
            label: 'Physical limitations',
            value: 'physicalLimitations',
            key: makeid(10),
          },
          {
            label: 'Other',
            value: 'other',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
      {
        key: makeid(10),
        label: 'Additional Details',
        type: 'text',
        name: 'accessToReadingHealtcareFreeText',
        required: false,
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Would you like access to your readings?',
    type: 'radio',
    required: false,
    name: 'accessToReading',
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Education provided on the call today:',
    type: 'checkbox',
    required: false,
    name: 'educationProvided',
    options: [
      {
        label: 'Benefits of the RPM Program',
        value: 'benefitRpmProgram',
        key: makeid(10),
      },
      {
        label: 'Importance of regularly taking your readings',
        value: 'importanceRegularReading',
        key: makeid(10),
      },
      {
        label: 'Device education/troubleshooting',
        value: 'deviceEducationTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Best practices for device utilization',
        value: 'bestPracticeForDeviceUtilization',
        key: makeid(10),
      },
    ],
    extra: [
      {
        key: makeid(10),
        label: 'Additional Details',
        title: 'Additional Details',
        type: 'text',
        name: 'eduAdditionalDetails',
        required: false,
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Additional educational materials sent?',
    type: 'radio',
    required: false,
    name: 'additionalEducationalMaterialsSent',
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    readingTypeFor: ['min'],
    extra: [
      {
        key: makeid(10),
        divider: true,
        required: false,
        label: 'Delivery Method',
        type: 'radio',
        name: 'deliveryMethod',
        options: [
          { label: 'Via Email', value: 'email', key: makeid(10) },
          { label: 'Via US Mail', value: 'usmail', key: makeid(10) },
        ],
        readingTypeFor: ['min'],
      },
    ],
  },
];

export const NoReadingsForm = [
  {
    key: makeid(10),
    type: 'info',
    title: 'No Readings Pathway',
    name: 'info',
    required: false,
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Device that patient has not been using',
    type: 'checkbox',
    name: 'usedDevice',
    required: true,
    options: [
      {
        label: 'Blood Pressure Device',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Glucometer',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Pulse Oximeter',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Weight Scale',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Peak Flow Meter',
        value: 'other',
        key: makeid(10),
      },
      {
        label: 'Sleep Mat',
        value: 'other',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Duration of time since last use',
    type: 'radio',
    required: true,
    name: 'lastUseDuration',
    options: [
      { label: '14 Days', value: '14', key: makeid(10) },
      { label: '30 Days', value: '30', key: makeid(10) },
      { label: '45 Days', value: '45', key: makeid(10) },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Reasons patient has stopped using the device',
    type: 'checkbox',
    name: 'reasonForStop',
    required: false,
    options: [
      {
        label: 'Device issue',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label: 'Doesn’t see the value of monitoring',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label: 'Forgetting to use the device',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label: 'Is not able to use daily',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Patient is able to take another reading at time of call?',
    type: 'radio',
    required: false,
    name: 'realTimeReading',
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    extra: [
      {
        key: makeid(10),
        divider: true,
        label: 'Was the reading within normal limits?',
        type: 'radio',
        name: 'isNormalLimits',
        options: [
          { label: 'Yes', value: 'yes', key: makeid(10) },
          { label: 'No', value: 'no', key: makeid(10) },
        ],
        readingTypeFor: ['min'],
      },
      {
        type: 'input',
        name: 'repeatReading',
        key: makeid(10),
        options: [
          {
            label: 'The repeat reading was:',
            value: 'repeatReading',
            key: makeid(10),
          },
        ],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    type: 'info',
    title: 'Patient education about importance of monitoring',
    name: 'info',
    readingTypeFor: ['min'],
    alignCenter: true,
    required: false,
    iconLink: '/img/info.svg',
  },
  {
    key: makeid(10),
    title: 'The importance of monitoring Blood Pressure/Pulse',
    type: 'checkbox',
    name: 'importanceBloodPressure',
    headerCollapse: true,
    headerIconLink: '/img/blood-pressure-monitor.svg',
    required: false,
    options: [
      {
        label:
          'Monitoring blood pressure changes at home can help you and your doctor make better decisions about your treatment',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label:
          'Help with early diagnosis. Self-monitoring can help your provider diagnose high blood pressure earlier than if you have only occasional blood pressure readings in a medical office',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label:
          'Help track your treatment. Monitoring blood pressure at home is a good way to know whether your lifestyle changes or medications are working',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'Encourage better control. Self-monitoring can give you a stronger sense of responsibility for your health',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          "Check if your blood pressure differs outside the doctor's office. Some people experience spikes in blood pressure due to anxiety associated with seeing a doctor (white coat hypertension)",
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    extra: [
      {
        key: makeid(10),
        divider: false,
        label: 'Situations the can raise your blood pressure:',
        type: 'checkbox',
        name: 'raiseBloodPressure',
        required: false,
        options: [
          {
            label:
              'Monitoring blood pressure changes at home can help you and your doctor make better decisions about your treatment',
            value: 'introductoryCall',
            key: makeid(10),
          },
          {
            label:
              'Help with early diagnosis. Self-monitoring can help your provider diagnose high blood pressure earlier than if you have only occasional blood pressure readings in a medical office',
            value: 'normalReadings',
            key: makeid(10),
          },
          {
            label:
              'Help track your treatment. Monitoring blood pressure at home is a good way to know whether your lifestyle changes or medications are working',
            value: 'deviceTroubleshoot',
            key: makeid(10),
          },
          {
            label:
              'Encourage better control. Self-monitoring can give you a stronger sense of responsibility for your health',
            value: 'noReadings',
            key: makeid(10),
          },
          {
            label:
              "Check if your blood pressure differs outside the doctor's office. Some people experience spikes in blood pressure due to anxiety associated with seeing a doctor (white coat hypertension)",
            value: 'noReadings',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
      {
        key: makeid(10),
        divider: false,
        label: 'Situations that can lower your blood pressure:',
        type: 'checkbox',
        name: 'lowerBloodPressure',
        required: false,
        options: [
          {
            label: 'Dehydration',
            value: 'introductoryCall',
            key: makeid(10),
          },
          {
            label: 'Severe infection',
            value: 'normalReadings',
            key: makeid(10),
          },
          {
            label: 'Severe allergic reaction',
            value: 'deviceTroubleshoot',
            key: makeid(10),
          },
          {
            label: 'Lack of nutrients in diet',
            value: 'noReadings',
            key: makeid(10),
          },
          {
            label: 'Blood loss',
            value: 'noReadings',
            key: makeid(10),
          },
          {
            label: 'Heart and valve diseases',
            value: 'noReadings',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'The importance of monitoring Weight (heart failure)',
    type: 'checkbox',
    name: 'importanceWeight',
    headerCollapse: true,
    headerIconLink: '/img/weight-scale.svg',
    required: false,
    options: [
      {
        label:
          'Weight gain is one of the first signs of retaining fluid and can mean your heart failure is getting worse',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label:
          'Patients can gain up to 10 pounds of extra weight from fluid before feeling bad or swelling',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label:
          'Your weight is one way to tell if your heart failure is getting worse or if you need changes in your medication to control extra fluid in your body',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'In general, if your weight goes up 2 pounds in one day or 5 pounds in one week, contact your Provider',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          'Often increases in weight can be easily dealt with by changing your diuretic (water pill)',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          "Do not be concerned if your weight on your home scale does not match your weight at your doctor's office. Scales can vary by several pounds. It is the change in weight that matters most",
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          'Contact your health care team right away to report weight gain. If you delay in calling your doctor you may need a hospital stay',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'The importance of Monitoring Blood Sugar',
    type: 'checkbox',
    name: 'importanceBloodSugar',
    headerCollapse: true,
    headerIconLink: '/img/glucometer.svg',
    required: false,
    options: [
      {
        label:
          'If you have diabetes, monitoring your blood sugar (glucose) is key to finding out how well your current treatment plan is working',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label:
          'It gives you information on how to manage your diabetes on a daily — and sometimes even hourly — basis',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label:
          'Monitoring your blood sugar is important when you have diabetes, especially if you use insulin',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'The results of blood sugar monitoring can help you make decisions about food, physical activity and dosing insulin',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label:
          'Several things can affect your blood sugar. You can learn to predict some of these impacts with time and practice, while others are very difficult or impossible to predict. That’s why it’s important to check your blood sugar regularly if your healthcare provider recommends doing so',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    extra: [
      {
        key: makeid(10),
        divider: false,
        label: 'Situations that can raise your blood sugar:',
        type: 'checkbox',
        name: 'raiseBloodSugar',
        required: false,
        options: [
          {
            label: 'Consuming carbohydrates',
            value: 'introductoryCall',
            key: makeid(10),
          },
          {
            label:
              'Not taking enough diabetes medication or insulin or missing a dose',
            value: 'normalReadings',
            key: makeid(10),
          },
          {
            label:
              'Consistent lack of exercise or getting less activity than you usually do',
            value: 'deviceTroubleshoot',
            key: makeid(10),
          },
          {
            label: 'Taking corticosteroid (steroid) medications',
            value: 'noReadings',
            key: makeid(10),
          },
          {
            label: 'Illness, surgery or stress',
            value: 'noReadings',
            key: makeid(10),
          },
          {
            label:
              'Dawn phenomenon (an early-morning rise in blood sugar that’s likely due to natural fluctuations in hormones, such as cortisol)',
            value: 'noReadings',
            key: makeid(10),
          },
          {
            label: 'Smoking',
            value: 'noReadings',
            key: makeid(10),
          },
          {
            label: 'Dehydration',
            value: 'noReadings',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
      {
        key: makeid(10),
        divider: false,
        label: 'Situations that can lower your blood sugar:',
        type: 'checkbox',
        name: 'lowerBloodSugar',
        required: false,
        options: [
          {
            label: 'Missing meals',
            value: 'introductoryCall',
            key: makeid(10),
          },
          {
            label: 'Taking too much diabetes medication or insulin',
            value: 'normalReadings',
            key: makeid(10),
          },
          {
            label: 'Physical activity',
            value: 'deviceTroubleshoot',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'The importance of monitoring Oxygen Level',
    type: 'checkbox',
    name: 'importanceOxygen',
    headerCollapse: true,
    headerIconLink: '/img/pulse-oximeter.svg',
    required: false,
    options: [
      {
        label:
          'Pulse oximetry is a non-invasive, pain free way to see how well your lungs are functioning',
        value: 'introductoryCall',
        key: makeid(10),
      },
      {
        label:
          'This is especially important in people living with COPD, emphysema, asthma, sleep apnea and other chronic lung conditions',
        value: 'normalReadings',
        key: makeid(10),
      },
      {
        label:
          'Pulse oximetry can also provide feedback about the effectiveness of breathing interventions, such as oxygen therapy and ventilators',
        value: 'deviceTroubleshoot',
        key: makeid(10),
      },
      {
        label:
          'Offers peace of mind to people with chronic respiratory or cardiovascular conditions',
        value: 'noReadings',
        key: makeid(10),
      },
      {
        label: 'Determining the need for supplemental oxygen',
        value: 'noReadings',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Additional Details',
    type: 'text',
    name: 'additionalDetailsMain',
    required: false,
    readingTypeFor: ['min'],
  },
];

export const WrapUpForm = [
  {
    key: makeid(10),
    type: 'info',
    title: 'Wrap Up',
    name: 'info',
    readingTypeFor: ['min'],
    alignCenter: true,
    required: false,
    iconLink: '/img/info-list.svg',
  },
  {
    key: makeid(10),
    title: 'MA inquired if patient has any other questions or concerns today?',
    type: 'radio',
    name: 'hasQuestions',
    required: false,
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    extra: [
      {
        key: makeid(10),
        type: 'text',
        name: 'questions',
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: '',
    type: 'checkbox',
    name: 'reminderTakeReadingsRegularly',
    required: false,
    options: [
      {
        label: 'Encouraged patient to continue taking their readings regularly',
        value: 'introductoryCall',
        key: makeid(10),
      },
    ],
    extra: [
      {
        key: makeid(10),
        label: 'Goal to use device:',
        type: 'radio',
        name: 'goalToUseDevice',
        required: false,
        options: [
          { label: 'Daily', value: 'Daily', key: makeid(10) },
          { label: 'Weekly', value: 'Weekly', key: makeid(10) },
          { label: 'Other', value: 'Other', key: makeid(10) },
        ],
        extra: [
          {
            type: 'input',
            name: 'goalToUseDeviceOther',
            key: makeid(10),
            options: [
              {
                label: 'Other goal:',
                value: 'goalToUseDeviceOther',
                key: makeid(10),
              },
            ],
          },
        ],
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },

  {
    key: makeid(10),
    title: '',
    type: 'checkbox',
    name: 'reminderMonitorHealthConditions',
    required: false,
    options: [
      {
        label:
          'Reminded patient that health conditions change over time. Continuing to monitor can help your doctor identify changes quickly so you can get care earlier and stay healthy longer',
        value: 'introductoryCall',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Does patient need any supplies?',
    type: 'radio',
    name: 'needConsumables',
    required: false,
    options: [
      { label: 'Yes', value: 'yes', key: makeid(10) },
      { label: 'No', value: 'no', key: makeid(10) },
    ],
    extra: [
      {
        key: makeid(10),
        type: 'checkbox',
        name: 'verifiedAddress',
        options: [
          {
            label: 'MA verified address, supplies ordered',
            value: 'MA verified address, supplies ordered',
            key: makeid(10),
          },
        ],
        readingTypeFor: ['min'],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: '',
    type: 'checkbox',
    name: 'transferCallToNursingTeam',
    required: false,
    options: [
      {
        label: 'Transferred call to nursing team',
        value: 'introductoryCall',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: 'Additional Details',
    type: 'text',
    name: 'additionalDetails',
    required: false,
    readingTypeFor: ['min'],
  },
];
